export const getHomeId = () => null;

export const getPubId = () => null;
